export const settings = {
  APP_NAME: "Green-Go Bus",
  APP_MAINTITLE: "Green-Go Bus",
  APP_SUBTITLE: "",
  API_SERVER: "https://api.greengobus.com",
  GOOGLE_MAPS_API_KEY: "AIzaSyBYbAhzukcfYFJjjDNDIy1q3fcwvjrEONI"
};
